<template>
  <div class='renewal'>
    <Header noNav></Header>
    <Loader v-if='isLoading' />
    <b-col @click='showResumeModal()' sm='12' class='renewal__show-details'>
      <p>Detalhes da renovação</p>
      <span />
    </b-col>
    <b-container>
      <b-row>
        <b-col sm='12' md='6'>
          <div class='renewal__description'>
            <h1 class='renewal__description--title'>Chegou a hora de <br /> renovar sua proteção!</h1>
            <p>Para continuar protegendo o seu aparelho, faça a renovação do seu bilhete de seguro. <b>Atenção: saiba que é necessário que o aparelho seja o mesmo da contratação anterior.</b></p>
            <p>A renovação estará disponível até {{ endAt }}. Se não for realizada até o fim do período, e ainda quiser proteger o aparelho, será necessária a contratação de uma novo seguro com período de carência de 30 dias.</p>
          </div>
          <div class='renewal__info'>
            <div class="renewal__info--wrapper">
              <div class='renewal__info--item'>
                <h2>Vigência atual</h2>
                <p><b>Início: </b>{{ startAt }}</p>
                <p><b>Término: </b>{{ endAt }}</p>
              </div>
              <div class='renewal__info--line'>
                <img class='renewal__info--icon' src="~@/assets/svg/arrow-horizontal-purple.svg" alt="" />
              </div>
              <div class='renewal__info--item'>
                <h2>Próxima vigência</h2>
                <p><b>Início: </b>{{ renewalStartDate }}</p>
                <p><b>Término: </b>{{ renewalExpirationDate }}</p>
              </div>
            </div>
            <div v-if='serialNumber' class='renewal__info--item'>
              <h2>Número do IMEI</h2>
              <p>{{ serialNumber }}</p>
            </div>
            <div class='renewal__info--item'>
              <p v-if='!serialNumber'><b>Voce ainda não incluiu o IMEI do aparelho!</b> Entre em contato conosco pelo falecom@ciclic.com.br para mais informações.</p>
            </div>
          </div>
          <div class='renewal__confirmation'>
            <b-button
              class='renewal__confirmation--btn'
              pill
              @click='startRenewal()'
              variant='purple'
              size='lg'
            >
              CONFIRMAR RENOVAÇÃO
            </b-button>
            <b-button
              class='renewal__confirmation--btn'
              pill
              @click='showResumeModal()'
              variant='outline-danger'
              size='lg'
            >
              DETALHES DA RENOVAÇÃO
            </b-button>
          </div>
        </b-col>
        <b-col md='6' class='renewal__resume' v-if="!hasModal">
          <div class='renewal__resume--title'>
            <h1>Resumo</h1>
          </div>
          <div class='renewal__resume--box-info'>
            <RenewalPaymentSummary
              :renewalDetails='{
                amount,
                installmentPrice,
                cellphoneUuid,
                discountAmount,
                promoCode,
              }'
              @applied='mountDetails'
              @canceled='promoCodeCanceled'
            />
          </div>
          <div class='renewal__resume--box-info'>
            <RenewalSummary :renewalDetails="{ name, coverage, renewalStartDate, renewalFranchise }" />
          </div>
        </b-col>
        <b-col sm='12' md='12'>
          <div class='renewal__disclaimer'>
            <p> A Ciclic S.A. sob o CNPJ 29.032.677/0001-93, https://www.ciclic.com.br/, sob a inscrição na SUSEP 20.2020304-7, sede na Rua Tenerife, 31 - 5º Andar - Vila Olímpia São Paulo SP CEP: 04548-040 é Corretora de Seguros da Assurant Seguradora S/A e está autorizada a comercializar o Seguro Celular Ciclic, Processo Susep Nº 15414.902134/2013-03. Restrições se aplicam. Consulte as Condições Gerais do Seguro antes de contratá-lo. O registro deste plano na SUSEP não implica, por parte da autarquia, incentivo ou recomendação à sua comercialização. Este seguro é garantido pela Assurant Seguradora S.A, sob o CNPJ 03.823.704/0001-52, sob sede na Alameda Rio Negro, 585, 3º andar, Bloco C, Alphaville, Barueri-SP, CEP: 06454-000, www.assurant.com.br, Inscrição Susep 0214-3. A CONTRATAÇÃO DO SEGURO É OPCIONAL SENDO POSSIVEL O CANCELAMENTO DO CONTRATO EM ATÉ 7 (SETE) DIAS CORRIDOS COM A DEVOLUÇÃO INTEGRAL DO VALOR PAGO. É proibido condicionar desconto no preço do bem à aquisição do seguro. A comercialização de seguro é fiscalizada pela SUSEP: www.susep.gov.br - 0800 021 8484. A Ciclic atua como intermediário do Programa de Seguros junto a Assurant Seguradora S.A. e, pela intermediação, recebe respectivamente o montante correspondente a porcentagem indicada, sobre o prêmio de seguro, de até 40%. O valor do prêmio total está somado a 7,38% de IOF. Os valores monetários finais do Prêmio Bruto, Prêmio Líquido e IOF estão descritos no bilhete de seguro, de acordo com a Resolução CNSP 285.</p>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      ref='renewal-resume-modal'
      size='lg'
      centered
      hide-footer
      body-bg-variant='white'
      static
      v-if="hasModal"
    >
      <div class='renewal__resume--payment'>
        <RenewalPaymentSummary
          :renewalDetails='{
            amount,
            installmentPrice,
            cellphoneUuid,
            discountAmount,
            promoCode,
          }'
          @applied='mountDetails'
          @canceled='promoCodeCanceled'
        />
      </div>
      <RenewalSummary
        :renewalDetails='{ name, coverage, renewalStartDate, renewalFranchise }'
      />
    </b-modal>
  </div>
</template>
<script>
import Header from '../Header/Header'
import RenewalPaymentSummary from './_components/RenewalPaymentSummary'
import RenewalSummary from './_components/RenewalSummary'
import Loader from '@/components/Loader'
import { mapState } from 'vuex'
import { checkoutData } from '@/utils/checkout'
import { getDataPolicy, getDataProduct, getPromoCode } from '@/api/services'
import moment from 'moment'

export default {
  name: 'Renewal',
  components: {
    Header,
    RenewalSummary,
    RenewalPaymentSummary,
    Loader
  },
  data () {
    return {
      isJustTheft: false,
      isLoading: true,
      discountAmount: '',
      previousPolicyUuid: '',
      oldValues: null,
      installmentPrice: '',
      installments: '',
      amount: '',
      name: '',
      cookieGA: '',
      dafault: {},
      promo: {},
      address: {},
      cellphonesDetails: null,
      startAt: '',
      endAt: '',
      coverage: '',
      itemUuid: '',
      cellphoneUuid: '',
      policyNumber: '',
      serialNumber: '',
      completePrice: '',
      promoCode: '',
      deviceTypeName: '',
      hasModal: false,
      renewalStartDate: '',
      renewalExpirationDate: '',
      renewalFranchise: ''
    }
  },
  computed: {
    ...mapState(['params', 'lead', 'appSettings'])
  },
  beforeMount () {
    window.sessionStorage.removeItem('ciclic:checkout')

    const { promoCode: promoCodeByParam } = this.$route.query || this.params
    const promoCodeBySession = sessionStorage.getItem('coupon')
    const promoCode = promoCodeByParam || promoCodeBySession

    if (promoCode) {
      this.promoCode = promoCode.toUpperCase()
    }
  },
  mounted () {
    this.hasModal = window.screen.width < 960
    this.getData()
  },
  methods: {
    showResumeModal () {
      this.$refs['renewal-resume-modal'].show()
    },
    async getData () {
      const { uuid } = this.$route.query || this.params
      await this.getPolicy(uuid)
      await this.getPhone(this.itemUuid)

      this.isLoading = false
    },
    async getPolicy (uuid) {
      if (!uuid) {
        return this.returnSearch()
      }

      await getDataPolicy(uuid)
        .then(({ data }) => {
          this.deviceTypeName = data.itemDto ? data.itemDto.deviceTypeName : data.item.deviceTypeName
          this.startAt = this.formateDate(data.startDate)
          this.endAt = this.formateDate(data.expirationDate)
          this.coverage = data.coverage === 'COMPLETE' ? 'Roubo, Furto, Quebra e Líquido' : 'Roubo e Furto'
          this.itemUuid = data.item.uuid
          this.policyNumber = data.policyNumber
          this.serialNumber = data.serialNumber
          this.personalData = data.person
          this.isJustTheft = data.coverage !== 'COMPLETE'
          this.previousPolicyUuid = uuid
          this.renewalStartDate = this.formateDate(data.renewalStartDate)
          this.renewalExpirationDate = this.formateDate(data.renewalExpirationDate)
        })
        .catch(this.returnSearch)
    },
    returnSearch () {
      this.$router.push({ name: 'RenewalSearch' })
    },
    async getPhone (uuid) {
      const getData = (await this.appSettings.promoCode.autoApply)
        ? getPromoCode({
            uuid,
            promoCode: this.appSettings.promoCode.code,
            isRenovation: true
          })
        : getDataProduct({ uuid, isRenovation: true })

      return getData
        .then(({ data }) => {
          this.mountDetails(data)
          this.oldValues = data
        })
    },
    mountDetails (data) {
      const cellphonesDetails = data.PROMO || data.DEFAULT
      const insuranceTypeList = this.isJustTheft
        ? ['theftPrice', 'theftPaymentOptions']
        : ['completePrice', 'completePaymentOptions']
      const newAmount = cellphonesDetails[insuranceTypeList[0]].replace(',', '.')
      const previousAmount = this.amount
      const defaultAmount = data.DEFAULT[insuranceTypeList[0]].replace(',', '.')
      const currentAmount = previousAmount || defaultAmount
      const instalments = cellphonesDetails[insuranceTypeList[1]]

      if (data.promoCode) {
        this.promoCode = data.promoCode
        this.discountAmount = currentAmount - newAmount
      }

      this.cellphonesDetails = cellphonesDetails
      this.installments = instalments
      this.installmentPrice = instalments[11]
      this.amount = newAmount
      this.promo = data.PROMO
      this.default = data.DEFAULT
      this.name = data.DEFAULT.name || data.PROMO.name
      this.cellphoneUuid = data.DEFAULT.uuid
      this.renewalFranchise = data.DEFAULT.franchise
    },
    promoCodeCanceled () {
      if (this.oldValues) this.mountDetails(this.oldValues)
      if (this.cellphoneUuid && !this.oldValues) this.getPhone(this.cellphoneUuid)
    },
    formateDate (date) {
      moment.locale('pt-br')

      return moment(date).format('LL')
    },
    startRenewal () {
      window.dataLayer.push({
        event: 'dispositivos-ciclic',
        categoria: 'dispositivos-renovacao',
        acao: 'click',
        rotulo: 'continuar'
      })

      checkoutData({
        deviceTypeName: this.deviceTypeName,
        previousPolicyUuid: this.previousPolicyUuid,
        isRenovation: true,
        default: this.discountAmount ? this.default : this.promo,
        promo: this.promo,
        cookieGA: this.params._ga,
        multiplicador: this.$store.getters.multiplier,
        nome: this.name,
        parcela: 12,
        parcelasPrecos: this.installments,
        preco: this.installmentPrice,
        somenteRoubo: this.isJustTheft,
        uuid: this.cellphoneUuid,
        precoTotal: this.amount,
        renewalStartDate: this.renewalStartDate,
        promoCode: this.promoCode,
        lead: null,
        pontuacao: null,
        personalData: this.personalData,
        discountAmount: this.discountAmount
      })

      const insuranceTypeList = this.isJustTheft
        ? ['theftPrice', 'theftPaymentOptions']
        : ['completePrice', 'completePaymentOptions']

      sessionStorage.setItem(
        'ciclic:device',
        JSON.stringify({
          nome: this.default.name,
          deviceTypeName: this.default.deviceTypeName
            ? this.default.deviceTypeName.toLowerCase()
            : null,
          parcela: this.appSettings.maxInstallment,
          parcelasPrecos: this.promo[insuranceTypeList[1]] || this.default[insuranceTypeList[1]],
          uuid: this.cellphoneUuid,
          somenteRoubo: this.isJustTheft,
          renewalStartDate: this.renewalStartDate
        })
      )

      setTimeout(() => {
        window.location.replace(`${process.env.VUE_APP_HOME_URL}checkout/#/dados-pessoais`)
      }, 1000)
    }
  }
}
</script>
<style lang='scss' scoped>
$breakpoint-nav: 960px;
$breakpoint-tablet: 768px;
$breakpoint-mobile: 480px;
$breakpoint-small-mobile: 320px;

.renewal {
  background-color: #f5f7fa;
  min-height: 100%;

  p {
    font-family: Rubik;
    font-size: 18px;
    margin: 0;
  }

  &__show-details {
    cursor: pointer;
    user-select: none;
    align-items: center;
    background-color: #ebf0f5;
    justify-content: space-between;
    display: none;
    @media only screen and (max-width: $breakpoint-mobile) {
      display: flex;
    }

    span {
      width: 40px;
      height: 40px;
      display: inline-block;
      position: relative;
      background: url(~@/assets/svg/arrow-horizontal.svg) no-repeat center;
    }
  }

  &__description {
    padding-bottom: 48px;
    margin-bottom: 48px;
    border-bottom: 1px solid rgba(190, 194, 198, 0.5);

    p {
      color: #595959;
      @media only screen and (max-width: $breakpoint-mobile) {
        font-size: 16px;
      }
    }

    &--title {
      font: bold 40px Oscine;
      color: #444444;
      margin: 36px 0 28px 0;
      @media only screen and (max-width: $breakpoint-mobile) {
        margin: 0 0 24px 0;
        font-size: 24px;
      }
    }
    :last-child {
      margin-top: 32px;
    }
  }

  &__info {
    margin-bottom: 48px;

    &--wrapper {
      display: flex;
      justify-content: space-between;
      margin-bottom: 28px;

      @media screen and (max-width: 767px) {
        flex-flow: column;
      }
    }

    &--line {
      position: relative;
      display: flex;
      justify-content: center;

        @media screen and (max-width: 767px) {
          margin-top: 16px;
          margin-bottom: 16px;
        }

        @media screen and (min-width: 768px) {
          align-items: center;
          margin-left: 16px;
          margin-right: 16px;
        }

      &:after {
        border-color: #D5D5D7;
        border-style: dashed;
        content: '';
        position: absolute;

        @media screen and (max-width: 767px) {
          border-bottom: 1px;
          top: 50%;
          width: 100%;
        }

        @media screen and (min-width: 768px) {
          border-left: 1px;
          left: 50%;
          height: 100%;
        }
      }
    }

    &--icon {
      height: 40px;
      position: relative;
      z-index: 1;
      width: 40px;

      @media screen and (max-width: 767px) {
        transform: rotate(90deg);
      }
    }

    h2 {
      color: #6320e9;
      font: bold 24px Oscine;
    }

    p {
      color: #747474;
      margin: 0;
    }
  }

  &__confirmation {
    // margin-bottom: 128px;
    display: flex;
    &--btn {
      padding-left: 2.5rem;
      padding-right: 2.5rem;
      display: inline-block;
      font: bold 16px Oscine;

      @media only screen and (max-width: $breakpoint-tablet) {
        padding-left: 12px;
        padding-right: 12px;
      }
      @media only screen and (max-width: $breakpoint-mobile) {
        width: 100%;
      }
    }
    :last-child {
      margin: 0 0 0 16px !important;
      color: #6320e9 !important;
      border-color: #6320e9 !important;
      display: none;
      @media only screen and (min-width: ($breakpoint-mobile + 1)) and (max-width: $breakpoint-nav) {
        display: block !important;
      }
    }
  }

  &__disclaimer {
    p {
      color: #bdc2c6;
      font-family: Rubik;
      font-size: 12px;
    }
  }

  &__resume {
    padding: 0 auto;

    &--title {
      margin: 0 auto;
      max-width: 416px;
      @media only screen and (max-width: $breakpoint-mobile) {
        display: none;
      }
      h1 {
        margin: 36px 0 0 0;
        font: bold 32px Oscine;
        color: #444444;
        @media only screen and (max-width: $breakpoint-mobile) {
          font-size: 24px;
          margin: 36px 0 0 0;
        }
      }
    }

    p {
      color: #444444;
      margin: 0;
    }

    &--box-info {
      background-color: white;
      border-radius: 8px;
      box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.06);
      margin: 24px auto 16px auto;
      max-width: 416px;
      padding: 40px 32px 5px 32px;
      & + & {
        padding: 40px 32px;
      }
    }

    &--payment {
      margin-bottom: 32px;
      border-bottom: 1px solid rgba(190, 194, 198, 0.5);
    }
  }
}
</style>
